import { z } from 'zod';
import { AREA_KEYS } from './areas.js';
/**
 * "Hoje" no Início: o que cada área da equipe tem de novo, em cartões curtos
 * (rótulo, título direto, uma linha de apoio) que levam à tela certa. Os
 * selos alimentam os cartões de "Sua equipe".
 */
export const todayCardSchema = z.object({
    id: z.string().min(1).max(60),
    area: z.enum(AREA_KEYS),
    /** Habilidade que deu origem ao cartão (a arte é o objeto dela). */
    skill: z.string().max(40),
    kicker: z.string().max(40),
    title: z.string().max(90),
    line: z.string().max(140),
    href: z.string().max(200),
    tone: z.enum(['neutral', 'warn', 'good']),
});
export const todaySchema = z.object({
    cards: z.array(todayCardSchema).max(8),
    badges: z.record(z.enum(AREA_KEYS), z.string().max(30).nullable()),
});
